import { Link } from "react-router-dom";
import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import Seo from "@/components/Seo";

export default function Impressum() {
  return (
    <>
      <Seo
        title="Impressum"
        description="Impressum und Anbieterkennzeichnung der Elite Swiss LLC, Sarasota, Florida."
      />
      <Header />
      <main className="bg-sand pb-24 pt-36 lg:pt-44" data-testid="impressum-page">
        <div className="mx-auto max-w-3xl px-6">
          <h1
            className="font-serif text-4xl tracking-tight text-ink sm:text-5xl"
            data-testid="impressum-title"
          >
            Impressum
          </h1>

          <section className="mt-12" data-testid="impressum-provider">
            <h2 className="font-serif text-2xl tracking-tight text-ink">
              Angaben zum Anbieter
            </h2>
            <p className="mt-5 text-base leading-relaxed text-ink-muted">
              Elite Swiss LLC
              <br />
              7255 Bee Ridge Rd
              <br />
              Sarasota, Florida, USA
            </p>
            <p className="mt-5 text-base leading-relaxed text-ink-muted">
              Vertretungsberechtigt: Renata Hofer (Geschäftsführung).
            </p>
          </section>

          <section className="mt-12" data-testid="impressum-contact">
            <h2 className="font-serif text-2xl tracking-tight text-ink">
              Kontakt
            </h2>
            <p className="mt-5 text-base leading-relaxed text-ink-muted">
              E-Mail:{" "}
              <a
                href="mailto:reni.a90@hotmail.com"
                data-testid="impressum-email-link"
                className="text-clay underline decoration-clay/40 underline-offset-4 transition-colors hover:decoration-clay"
              >
                reni.a90@hotmail.com
              </a>
              <br />
              Telefon:{" "}
              <a
                href="tel:+13055294140"
                data-testid="impressum-phone-link"
                className="text-clay underline decoration-clay/40 underline-offset-4 transition-colors hover:decoration-clay"
              >
                +1 305 529 4140
              </a>
              <br />
              Am schnellsten erreichen Sie uns über das{" "}
              <Link
                to="/kontakt"
                data-testid="impressum-form-link"
                className="text-clay underline decoration-clay/40 underline-offset-4 transition-colors hover:decoration-clay"
              >
                Kontaktformular
              </Link>
              .
            </p>
          </section>

          <section className="mt-12" data-testid="impressum-note">
            <h2 className="font-serif text-2xl tracking-tight text-ink">
              Hinweis
            </h2>
            <p className="mt-5 text-base leading-relaxed text-ink-muted">
              Die Inhalte dieser Website dienen der allgemeinen Information und
              stellen keine Rechts- oder Steuerberatung dar.
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}
